/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import {
  infoPanelTabs,
  sideDrawerContentContainer,
  tabContent,
  tabsContainer,
} from './SideDrawerContent.styles'
import { Tabs } from '@app/components/Molecules/Tabs'
import { useState } from 'react'
import { HazardsTab } from './HazardsTab'
import { DetailsTab } from './DetailsTab'

export const SideDrawerContent = () => {
  const theme = useTheme()
  const [currentTabIndex, setCurrentTabIndex] = useState(0)

  const tabs = [
    {
      label: 'Property Details',
      content: (
        <Box css={tabContent({ theme })}>
          <DetailsTab></DetailsTab>
        </Box>
      ),
      value: 'details',
    },
    {
      label: 'Hazards',
      content: (
        <Box css={tabContent({ theme })}>
          <HazardsTab></HazardsTab>
        </Box>
      ),
      value: 'hazards',
    },
  ]
  return (
    <Box css={sideDrawerContentContainer()}>
      <Box css={tabsContainer}>
        <Tabs
          css={infoPanelTabs({ theme })}
          handleChangeTab={(index) => setCurrentTabIndex(index)}
          tabs={tabs}
          color="uintel"
          tabIndex={currentTabIndex}
        />
      </Box>
    </Box>
  )
}
